import { Crosshair } from "lucide-react";

export default function Nav() {
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-40 border-b border-zinc-900 bg-black/90 backdrop-blur-md"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12 lg:px-20">
        <a
          href="#top"
          data-testid="brand-link"
          className="group flex items-center gap-3"
        >
          <span className="grid h-9 w-9 place-items-center border border-[#ff6b00] bg-black text-[#ff6b00] transition-transform duration-150 group-hover:-translate-y-0.5">
            <Crosshair className="h-5 w-5" strokeWidth={2.4} />
          </span>
          <span className="font-display text-2xl leading-none tracking-widest text-zinc-100">
            BIIPOD<span className="text-[#ff6b00]">.</span>MODDING
          </span>
        </a>
        <div className="hidden items-center gap-8 md:flex">
          <a href="#service" className="font-hud text-sm uppercase tracking-widest text-zinc-400 transition-colors duration-150 hover:text-[#ff6b00]" data-testid="nav-service">
            Service
          </a>
          <a href="#how" className="font-hud text-sm uppercase tracking-widest text-zinc-400 transition-colors duration-150 hover:text-[#ff6b00]" data-testid="nav-how">
            How It Works
          </a>
          <a href="#reviews" className="font-hud text-sm uppercase tracking-widest text-zinc-400 transition-colors duration-150 hover:text-[#ff6b00]" data-testid="nav-reviews">
            Reviews
          </a>
          <a href="#faq" className="font-hud text-sm uppercase tracking-widest text-zinc-400 transition-colors duration-150 hover:text-[#ff6b00]" data-testid="nav-faq">
            FAQ
          </a>
          <a
            href="#order"
            data-testid="nav-cta"
            className="inline-flex items-center border border-[#ff6b00] bg-[#ff6b00] px-4 py-2 font-hud text-sm font-semibold uppercase tracking-widest text-black transition-transform duration-150 hover:-translate-y-0.5 hover:bg-[#ff8125]"
          >
            Initiate Order
          </a>
        </div>
        <a
          href="#order"
          data-testid="nav-cta-mobile"
          className="inline-flex items-center border border-[#ff6b00] bg-[#ff6b00] px-3 py-1.5 font-hud text-xs font-semibold uppercase tracking-widest text-black md:hidden"
        >
          Order
        </a>
      </div>
    </nav>
  );
}
